import { getRequest } from '../../../api/utils/provider';
import { ApiResponse } from '../../../api/utils/responseTransform';

export async function getRiderServices(): Promise<ApiResponse<{ services: RiderService[] }>> {
  return getRequest('services');
}

export async function getServiceFilterOptions(
  signal?: AbortSignal
): Promise<ApiResponse<{ services: RiderServiceFilterOption[] }>> {
  return getRequest('services/lookup', signal);
}
